<template>
  <div class="niohouse-card-container" @click="handleNavigate">
    <div class="niohouse-card-banner">
      <img :src="niohouse.list_info.image" alt="banner" />
    </div>
    <div class="niohouse-card-content">
      <div class="niohouse-card-title">
        <span class="title-text">{{ niohouse.detail.name }}</span>
        <div class="title-right">
          <HIconNavigationS :size="14" @click.stop="handleOpenMap()"></HIconNavigationS>
          <span>{{ niohouse.detail.distance_desc }}</span>
        </div>
      </div>

      <!-- 有tags时的布局 -->
      <div v-if="props.niohouse.list_info.tags?.length > 0" class="niohouse-card-layout-with-tags">
        <!-- 第一行：tags 和 business-time-desc -->
        <div class="niohouse-card-row">
          <div class="niohouse-card-tags">
            <div class="tag" v-for="(tag, index) in props.niohouse.list_info.tags" :key="index">
              {{ tag.text }}
            </div>
          </div>
          <p class="business-time-desc">{{ niohouse.list_info.hints?.[0]?.text }}</p>
        </div>
        <!-- 第二行：sub_hints -->
        <div v-if="niohouse.list_info.sub_hints && niohouse.list_info.sub_hints.length > 0" style="margin-top: 8px" class="niohouse-card-description">
          {{ niohouse.list_info.sub_hints?.[0]?.text }}
        </div>
      </div>

      <!-- 没有tags时的布局 -->
      <div v-else class="niohouse-card-layout-without-tags">
        <div class="niohouse-card-row">
          <div class="niohouse-card-description" :style="{ color: niohouse.list_info.sub_hints?.[0]?.font_color }" v-if="niohouse.list_info.sub_hints && niohouse.list_info.sub_hints.length > 0">
            {{ niohouse.list_info.sub_hints?.[0]?.text }}
          </div>
          <div class="niohouse-card-description" v-else-if="niohouse.detail.rating">
            {{ niohouse.detail.rating }}
          </div>
          <p class="business-time-desc">{{ niohouse.list_info.hints?.[0]?.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { HIconNavigationS } from '@nio-fe/horo-icons';
import { isInApp } from './utils/index';
import openMap from './utils/index';
import { nioJsBridge } from '@nio-wad/universal-bridge-h5';
import { h5BaseUrl } from './utils/baseUrl';
import { getEnv } from './utils/index';

// interface NiohouseCardProps {
//   niohouse: {
//     code: string;
//     name: string;
//     type: string;
//     sub_type?: string;
//     distance: string;
//     exhibition_model?: string;
//     rating?: string;
//     business_time_desc: string;
//     images: string[];
//     tags: string[];
//     location: {
//       address: string;
//       address_name: string;
//       distance: string;
//       longitude: string;
//       latitude: string;
//     };
//   };
//   brand: string;
// }

interface NiohouseCardProps {
  niohouse: {
    detail: {
      id: string;
      name: string;
      type?: string;
      sub_type: string;
      distance_desc: string;
      location: string;
      rating?: string;
      link: string;
    };
    list_info: {
      title: string;
      image: string;
      tags: {
        text: string;
        font_color: string;
        background_color: string;
      }[];
      hints: {
        text: string;
        font_color: string;
      }[];
      sub_hints?: {
        text: string;
        font_color: string;
      }[];
    };
  };
  brand: string;
}

const props = defineProps<NiohouseCardProps>();

// const navigateToAppPartnerDetail = () => {
//   if (isInApp) {
//     nioJsBridge.openURL({
//       data: {
//         url: `nio://service/charge_map?scene=welfare&id=${props.niohouse.detail.id}&sub_type=${
//           props.niohouse.detail.sub_type || 'experience'
//         }`,
//       },
//     });
//   }
// };

// const navigateToNiohouseDetail = async () => {
//   const { id } = props.niohouse.detail;

//   if (isInApp) {
//     nioJsBridge.openURL({
//       data: {
//         url: `${
//           h5BaseUrl[await getEnv()]
//         }/niohouse?code=${id}&recommend_location=&is_nav_show=false&wv=lg`,
//       },
//     });
//   }
// };

const handleNavigate = () => {
  if (isInApp) {
    nioJsBridge.openURL({
      data: {
        url: props.niohouse.detail?.link,
      },
    });
  }
};

const handleOpenMap = () => {
  const nioHouseData = props.niohouse;
  if (isInApp) {
    const type = nioHouseData.detail.sub_type;
    openMap(
      nioHouseData.detail.location.split(',')[0], // latitude
      nioHouseData.detail.location.split(',')[1], // longitude
      nioHouseData.detail.name,
      nioHouseData.detail.id,
      type
    );
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.niohouse-card-container {
  display: flex;
  padding: 10px;
  background-color: #fff;

  .niohouse-card-banner {
    width: 70px;
    height: 70px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .niohouse-card-content {
    flex: 1;
    margin-left: 10px;
    min-width: 0;
  }

  // 新增：通用行布局
  .niohouse-card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    color: #686d82;
    font-size: 12px;
    line-height: 18px;
  }

  // 有tags时的布局容器
  .niohouse-card-layout-with-tags {
    margin-top: 5px;
  }

  // 没有tags时的布局容器
  .niohouse-card-layout-without-tags {
    margin-top: 5px;
  }

  .niohouse-card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    color: #050b27;

    .title-text {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .title-right {
      display: flex;
      align-items: center;
      gap: 4px;
      flex-shrink: 0;
      font-size: 12px;
    }
  }

  .niohouse-card-description {
    color: #686d82;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }

  .niohouse-card-tags {
    display: flex;
    flex-wrap: nowrap;
    gap: 3px;
    flex-shrink: 0;
    max-width: 60%;
    overflow: hidden;
  }

  .tag {
    padding: 3px 5px;
    font-size: 10px;
    line-height: 14px;
    background-color: #f7f7f7;
    color: #686d82;
  }

  .business-time-desc {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
  }
}
</style>
